import { Component, Input } from '@angular/core';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ResponsiveService } from '../../../shared/services/responsive.service';
import { RouteContextService } from '../../../shared/services/route-context.service';
import { TranslationGeneralService } from '../../../shared/translation/translation.general.service';
import { AuthService } from '../../../user/auth.service';
import { UserService } from '../../../user/user.service';
import { NavigationService } from '../../../whoo/core/navigation.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateMigratedPipe } from '../../../shared/translation/trans-migrated.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface DialogData {
    animal: string;
    name: string;
}

@Component({
    selector: 'nav-create-poll-button',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        TranslateMigratedPipe,
    ],
    templateUrl: './create-poll-button.component.html',
    styleUrls: ['./create-poll-button.component.scss'],
})
export class NavCreatePollButtonComponent {

    constructor(
        public authService: AuthService,
        public userService: UserService,
        public responsiveService: ResponsiveService,
        private logger: LoggerService,
        public trans: TranslationGeneralService,
        public navigationService: NavigationService,
        public routeContextService: RouteContextService
    ) { }

    get disableCreatePollButton(): boolean {
        if (this.routeContextService.id === 'createPoll' || this.routeContextService.id === 'choosePollTemplate') {
            return true;
        }
        return false;
    }


    navigateToChoosePollTemplate(): void {
        this.navigationService.navigateChoosePollTemplate();
    }


}
